import {User} from "../auth/types";
import {useState} from "react";
import {getAccountsApiHost} from "../../env/env";

type AccountPermissions = {
  canDelete: boolean;
  canSwitchToEdu: boolean;
}

const API = getAccountsApiHost();

const getProfile = async (user: User): Promise<AccountPermissions> => {
  const token = await user.getIdToken();
  const resp = await fetch(`${API}/permissions`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return resp.json();
}

export const useAccountPermissions = (user: User | null) => {
  const [profile, setProfile] = useState<AccountPermissions>();
  if (!user || profile) {
    return profile;
  }
  getProfile(user).then((resp) => setProfile(resp))
}